<style>
  .con-vs-popup .vs-popup {
    width: auto !important;
  }
</style>
<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord(params.id)"
    />
    <!-- <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" /> -->
    
    <feather-icon icon="SettingsIcon" svgClasses="ml-5 h-5 w-5 hover:text-danger cursor-pointer" @click="showContacts" />

    <vs-popup
        class="holamundo"
        title="Advanced Settings - Booth Contacts"
        :active.sync="popupContacts"
      >
        <div class="flex flex-wrap items-center">
          <div class="flex-grow">
            <vs-table :data="MappedContacts">
                <template slot="thead">
                  <vs-th>First Name</vs-th>
                  <vs-th>Last Name</vs-th>
                  <vs-th>Email</vs-th>
                  <vs-th>Streaming Client</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].FirstName">{{
                      data[indextr].FirstName
                    }}</vs-td>
                    <vs-td :data="data[indextr].LastName">{{
                      data[indextr].LastName
                    }}</vs-td>
                    <vs-td :data="data[indextr].Email">{{
                      data[indextr].Email
                    }}</vs-td>
                    <vs-td >
                      <input
                        class="mr-2"
                        type="radio"
                        :name="`StreamingClient_${indextr}`"
                        v-bind:checked="data[indextr].StreamingClient!='Zoom' ? true : false"
                        :disabled="data[indextr].StreamingClient=='Zoom'"
                        @change="saveStreamingClient(data[indextr], 'Web')"
                        >Web
                      <input
                        class="mr-2"
                        type="radio"
                        :name="`StreamingClient_${indextr}`"
                        v-bind:checked="data[indextr].StreamingClient=='Zoom' ? true : false"
                        :disabled="data[indextr].StreamingClient=='Zoom'"
                        @change="saveStreamingClient(data[indextr], 'Zoom')"
                        >Zoom
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
          </div>
        </div>
    </vs-popup>

  </div>
</template>

<script>
export default {
  name: "CellRendererActions",
  data() {
    return {
      popupContacts: false,
      MappedContacts:[]
    }
  },
  watch: {
  },
  methods: {
    // editRecord () {
    //   this.$router.push(`event/exhibitor/add/${268}`).catch(() => {})
    // },
    saveStreamingClient(AttendeeObj, StreamingClient){
      if(StreamingClient == 'Zoom')
      {
        this.popupContacts = false;
        this.$vs.loading();
         this.$store
        .dispatch("exhibitorManagement/saveStreamingClientZoom",{
          AttendeeObj:AttendeeObj,
          StreamingClient: StreamingClient,
          ExhibitorId: this.params.id,
          exhibitorDetail: this.params.data
        })
        .then((res) => {
          this.$vs.loading.close();
          if(res.status == 200)
          {
            this.$vs.notify({
                color: "success",
                position: "top-center",
                text: res.message,
              });
            location.reload();
          }
          else
          {
            this.$vs.notify({
                color: "warning",
                position: "top-center",
                text: res.message,
              });
          }
        });
      }
    },
    showContacts(){
      this.MappedContacts = this.params.data.MappedContacts
      this.popupContacts = true;
    },
    editRecord(id) {
      console.log("asdfasf" + id);
      this.$router
        .push({
          name: "exhibitor-edit",
          params: {
            exhibitorId: id
          }
        })
        .catch(() => {});
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete "${this.params.data.username}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "User Deleted",
        text: "The selected user was successfully deleted"
      });
    },
  }
};
</script>
